<template>
    <social-sharing :url="`${domain}${url}`" class="bk-card-share" inline-template>
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret right>
            <template slot="button-content">
                <span class="material-icon icon-share"></span>
            </template>
            <b-dropdown-item-button>
                <network network="facebook">
                    <font-awesome-icon :icon="['fab', 'facebook-f']"/>
                    Facebook
                </network>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
                <network network="googleplus">
                    <font-awesome-icon :icon="['fab', 'google']"/>
                    Google +
                </network>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
                <network network="linkedin">
                    <font-awesome-icon :icon="['fab', 'linkedin']"/>
                    <i class="fa fa-fw fa-linkedin"></i> LinkedIn
                </network>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
                <network network="pinterest">
                    <font-awesome-icon :icon="['fab', 'pinterest']"/>
                    <i class="fa fa-fw fa-pinterest"></i> Pinterest
                </network>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
                <network network="reddit">
                    <font-awesome-icon :icon="['fab', 'reddit']"/>
                    <i class="fa fa-fw fa-reddit"></i> Reddit
                </network>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
                <network network="twitter">
                    <font-awesome-icon :icon="['fab', 'twitter']"/>
                    <i class="fa fa-fw fa-twitter"></i> Twitter
                </network>
            </b-dropdown-item-button>
            <!--<b-dropdown-item-button>
                <network network="vk">
                    <font-awesome-icon :icon="['fab', 'vk']"/>
                    <i class="fa fa-vk"></i> VKontakte
                </network>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
                <network network="weibo">
                    <font-awesome-icon :icon="['fab', 'weibo']"/>
                    <i class="fa fa-weibo"></i> Weibo
                </network>
            </b-dropdown-item-button>-->
            <b-dropdown-item-button>
                <network network="whatsapp">
                    <font-awesome-icon :icon="['fab', 'whatsapp']"/>
                    <i class="fa fa-fw fa-whatsapp"></i> Whatsapp
                </network>
            </b-dropdown-item-button>
        </b-dropdown>
    </social-sharing>
</template>

<script>
    export default {
      props: ['url'],
    }
</script>
